const CHAT_TOOL_NAME_LABELS: Record<string, string> = {
  fetch_url: 'Lecture de page',
  generate_document: 'Génération documentaire',
  revise_document: 'Révision documentaire',
  web_search: 'Recherche web',
};

export function getChatToolDisplayName(toolName: string) {
  return CHAT_TOOL_NAME_LABELS[toolName] ?? toolName;
}
